import { css } from 'lit';

export const commonStyles = css`
  *,
  *:before,
  *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  input,
  button {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  a {
    color: #2b2b2b;
    text-decoration: none;
  }
  a:hover,
  a:focus {
    text-decoration: underline;
  }

  ul,
  ol {
    margin-top: 0;
    margin-bottom: floor((13px * 1.428571429)) !default; * 0.5;
    padding-left: 0;
    list-style: none;
  }

  .button:active {
    margin-top: 0;
  }

  ::-webkit-input-placeholder {
    font-size: 15px;
    color: #a9a9a9;
  }
  
  :-moz-placeholder {
    font-size: 15px;
    color: #a9a9a9;
    opacity: 1;
  }
  
  ::-moz-placeholder {
    font-size: 15px;
    color: #a9a9a9;
    opacity: 1;
  }
  
  :-ms-input-placeholder {
    font-size: 15px;
    color: #a9a9a9;
  }

  .proposal-box-checkbox {
    border-radius: 5px;
    padding: 8px;
    margin: 8px 0;
    display: flex;
    align-items: center;
  
    label, .proposal-label {
      margin-left: 16px !important;
      font-size: 12px !important;
      font-style: italic;
    }
  
  }

  .proposal-box-border {
    box-shadow: 0 0 0 1px #ff206e;
    margin: 16px 0 !important;
  }

  
  hr {
    border-color: #ff206e;
    border-width: 0.5px;
  }  
`